import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { Signature } from '@/types/signature';
import type { AcctTxSignableDecision } from '@mls-wallet/shared-types';

export type TransactionSignatureIntent = Signature & { proposalId: string };

type CreateTransactionSignatureArg = {
  transactionId: string;
  decision: AcctTxSignableDecision;
  reason?: string | undefined;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: CreateTransactionSignatureArg }
): Promise<TransactionSignatureIntent[]> => {
  const { transactionId, decision, reason } = arg;
  return await denApi.post<
    TransactionSignatureIntent[],
    Omit<CreateTransactionSignatureArg, 'transactionId'>
  >(`transactions/${encodeURIComponent(transactionId)}/signatures`, {
    decision,
    reason,
  });
};

export function useCreateTransactionSignature(
  swrOptions?: SWRMutationConfiguration<
    TransactionSignatureIntent[],
    Error,
    string,
    CreateTransactionSignatureArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    TransactionSignatureIntent[],
    Error,
    string,
    CreateTransactionSignatureArg
  >('transactions/signatures', fetcher, swrOptions);

  return { createSignature: trigger, isLoading: isMutating, error };
}
